/**
 * @file 文档页页面面包屑
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {Breadcrumb} from 'antd';
import {RightOutlined} from '@ant-design/icons';

import {ITutorialsBreadcrumbItem} from '../../type';
import LinkA from '../../../../components/a/LinkA';

interface IProps {
    breadcrumbsList: ITutorialsBreadcrumbItem[];
}

const DocBreadcrumb: React.FC<IProps> = props => {
    const breadcrumbsList = props.breadcrumbsList;

    return (
        <Breadcrumb
            className="paddle-doc-breadcrumb"
            separator={<RightOutlined />}
        >
            {breadcrumbsList.filter(Boolean).map(item => (
                <Breadcrumb.Item key={item.id}>
                    <LinkA to={item.link || ''}>
                        {item.title}
                    </LinkA>
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
};

export default DocBreadcrumb;
